/**
 * Combina todos los reducers de Kanban en un solo reducer
 * Implementa el principio de Composición de Interfaces (ISP) permitiendo que cada reducer
 * maneje solo las acciones que le corresponden
 */
import { combineReducers } from 'redux';
import boardReducer from './boardReducer';
import columnReducer from './columnReducer';
import ticketReducer from './ticketReducer';
import commentReducer from './commentReducer';
import historyReducer from './historyReducer';

/**
 * Reducer combinado para el módulo Kanban
 * Cada sub-reducer maneja una parte específica del estado
 */
const rootKanbanReducer = combineReducers({
  boards: boardReducer,
  columns: columnReducer,
  tickets: ticketReducer,
  comments: commentReducer,
  history: historyReducer
});

export default rootKanbanReducer;
